module.exports = __webpack_public_path__ + "static/media/marcas (4).bab428df.jpg";